module.exports = __webpack_public_path__ + "static/media/contact.030a34c8.png";